import React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';

export default function Hero() {
    return (
        <Box
            id="hero"
            sx={{
                width: '100%',
                height: '70vh',
                backgroundImage: 'url(/img/bg-scaled.jpg)',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundBlendMode: 'overlay',
                display: 'flex',
                alignItems: 'center',
            }}
        >
            <Container maxWidth="lg">
                <Grid container spacing={2} alignItems="center">
                    <Grid item xs={12} sm={6}>
                        <Box sx={{ textAlign: 'left', color: 'white' }}>
                            <Typography
                                variant="h1"
                                sx={{
                                    fontSize: 'clamp(2.5rem, 8vw, 4rem)',
                                    fontWeight: 'bold',
                                    mb: 2,
                                }}
                            >
                                Empower, Connect, Grow!
                            </Typography>
                            <Typography
                                variant="h6"
                                sx={{
                                    fontSize: '16px',
                                    color: 'rgba(255, 255, 255, 0.85)',
                                    mb: 4,
                                }}
                            >
                                Our mission is to empower individuals with practical cybersecurity and cloud engineering skills,
                                while enabling organizations to strengthen their cybersecurity resilience.
                            </Typography>
                            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    size="large"
                                    href="/apply"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    Join Us Today
                                </Button>
                            </Stack>
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={6}></Grid>
                </Grid>
            </Container>
        </Box>
    );
}
